var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClean(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-cross-small"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.9998 7.00003C20.781 6.78132 20.4843 6.65845 20.175 6.65845C19.8656 6.65845 19.5689 6.78132 19.3501 7.00003L13.9998 12.3504L8.64945 7.00003C8.43067 6.78132 8.13398 6.65845 7.82462 6.65845C7.51526 6.65845 7.21857 6.78132 6.99979 7.00003C6.78107 7.21881 6.6582 7.51551 6.6582 7.82486C6.6582 8.13422 6.78107 8.43092 6.99979 8.6497L12.3501 14L6.99979 19.3504C6.78107 19.5691 6.6582 19.8658 6.6582 20.1752C6.6582 20.4846 6.78107 20.7812 6.99979 21C7.21857 21.2187 7.51526 21.3416 7.82462 21.3416C8.13398 21.3416 8.43067 21.2187 8.64945 21L13.9998 15.6497L19.3501 21C19.5689 21.2187 19.8656 21.3416 20.175 21.3416C20.4843 21.3416 20.781 21.2187 20.9998 21C21.2185 20.7812 21.3414 20.4846 21.3414 20.1752C21.3414 19.8658 21.2185 19.5691 20.9998 19.3504L15.6495 14L20.9998 8.6497C21.2185 8.43092 21.3414 8.13422 21.3414 7.82486C21.3414 7.51551 21.2185 7.21881 20.9998 7.00003Z",
    fill: "#2E2360"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClean);
export default __webpack_public_path__ + "static/media/Clean.3ddb65f06169313fc72c9c4e99e97b9e.svg";
export { ForwardRef as ReactComponent };